import { useIntl } from "react-intl";
import AsyncSelect from "@ticketingplatform/ui/dist/components/atoms/Fields/Select/AsyncSelect";

import { usePaymentTerminalSelect } from "./hooks";
import { PaymentTerminalSelectProps } from "./types";

const PaymentTerminalSelect: React.FC<PaymentTerminalSelectProps> = ({
  value,
  onChange,
  ...props
}) => {
  const intl = useIntl();
  const paymentTerminalSelect = usePaymentTerminalSelect({ value, onChange });

  return (
    <AsyncSelect
      {...paymentTerminalSelect}
      placeholder={intl.formatMessage({
        defaultMessage: "Choose Payment Terminal",
      })}
      {...props}
    />
  );
};

export default PaymentTerminalSelect;
